/* eslint-disable react/display-name */
import type * as React from 'react';

import { BrazeConsumer } from '../braze-consumer/braze-consumer';
import { BrazeContext } from '../braze-provider/braze-provider';
import type { Prescreen } from '../consumers/prescreen-consumer/prescreen-consumer';
import type { SlideUp } from '../consumers/slide-up-consumer/slide-up-consumer';
import type { Teaser } from '../consumers/teaser-consumer/teaser-consumer';
import type { Placement } from '../placements';

const withBraze =
  (placement: Placement) =>
  (
    OpenComponent: typeof Teaser | typeof Prescreen | typeof SlideUp,
    EmptyComponent: React.FC = () => null
  ) =>
  () => (
    <BrazeContext.Consumer>
      {({ subscribeConsumer, trackingLibrary }) => {
        return (
          <BrazeConsumer
            placement={placement}
            subscribeConsumer={subscribeConsumer}
            openComponent={OpenComponent}
            emptyComponent={EmptyComponent}
            trackingLibrary={trackingLibrary}
          />
        );
      }}
    </BrazeContext.Consumer>
  );

export default withBraze;
